import React, { useMemo } from 'react'
import { Table, Form } from '@themesberg/react-bootstrap'

const CountryTable = ({
  loading,
  myCountries,
  selectedCountries,
  handleCountrySelect,
  setSelectedCountries,
  enableEdit
}) => {
  const selectedSet = useMemo(() => new Set(selectedCountries), [selectedCountries])

  const allSelected = useMemo(() => myCountries.length > 0 && myCountries.every(({ code }) => selectedSet.has(code)), [myCountries, selectedSet])

  const someSelected = useMemo(() => myCountries.some(({ code }) => selectedSet.has(code)), [myCountries, selectedSet])

  const handleSelectAllChange = () => {
    if (allSelected) {
      // Deselect all
      setSelectedCountries([])
    } else {
      // Select all
      const allCodes = myCountries.map(({ code }) => code)
      setSelectedCountries(allCodes)
    }
  }

  return (
    <div style={{ overflowY: 'auto', maxHeight: '600px' }}>
      {loading
        ? (
          <div id='inline-spinner' />
          )
        : (
          <Table
            bordered
            striped
            hover
            size='sm'
            className='text-center mt-3 fixTableHead'
          >
            <thead className='thead-dark'>
              <tr>
                <th>Country</th>
                {enableEdit && <th>
                  <div className='d-flex justify-content-center align-items-center'>
                    <Form.Check
                      type='checkbox'
                      className='mr-2'
                      checked={allSelected}
                      ref={el => {
                        if (el) el.indeterminate = !allSelected && someSelected
                      }}
                      onChange={handleSelectAllChange}
                    />
                    &nbsp; Select
                  </div>
                </th>}
              </tr>
            </thead>
            <tbody>
              {myCountries?.length > 0
                ? (
                    myCountries.map(({ name, code }) => (
                      (enableEdit || selectedCountries.includes(code))
                        ? <tr key={code}>
                          <td>{name}</td>
                          {enableEdit && <td>
                            <Form.Check
                              type='checkbox'
                              checked={selectedCountries.includes(code)}
                              onChange={() => handleCountrySelect(code)}
                            />
                          </td>}
                        </tr>
                        : null
                    ))
                  )
                : (
                  <tr>
                    <td colSpan={enableEdit ? 2 : 1} className='text-danger text-center'>
                      No data found
                    </td>
                  </tr>
                  )}
            </tbody>
          </Table>
          )}
    </div>
  )
}

export default CountryTable
